import React from 'react';
import { components, OptionProps } from 'react-select';

import { SelectOption } from './Select.types';

const Option = (props: OptionProps<SelectOption>) => (
  <components.Option className={props.data.className} {...props} />
);
export default Option;
